export const casePrepBuddySourceOptions = [
  {
    id: 'unsure',
    step: 'unsure',
    title: "I don't know",
    badge: 'Guided help',
    description:
      'Find out more about addresses, transactions, hashes, and blockchain-investigation concepts before you continue.'
  },
  {
    id: 'address',
    step: 'addressIntent',
    title: 'I have an address',
    badge: 'Address flow',
    description:
      'Review an address to see what it adds to the case.'
  },
  {
    id: 'transaction',
    step: 'transaction',
    title: 'I have a transaction',
    badge: 'Transaction flow',
    description:
      'Paste one transaction hash or a batch of transaction hashes.'
  },
  {
    id: 'csv',
    step: 'csv',
    title: 'I have a transaction history CSV / TSV from an exchange',
    badge: 'Transaction History',
    description:
      'Upload a CSV or TSV file that came from an exchange.'
  },
  {
    id: 'spreadsheet',
    step: 'spreadsheet',
    title: 'I have a spreadsheet',
    badge: 'Spreadsheet',
    description:
      'If you have a spreadsheet with the transactions organized already, you can upload it here.'
  },
  {
    id: 'screenshots',
    step: 'screenshots',
    title: 'I have screenshots',
    badge: 'Image Reader',
    description:
      'Upload screenshots to extract hashes'
  },
  {
    id: 'document',
    step: 'document',
    title: 'I have a document',
    badge: 'Document extraction',
    description:
      'Upload documents to extract hashes'
  }
];

export function getCasePrepBuddySourceOptionByStep(step) {
  return casePrepBuddySourceOptions.find((option) => option.step === step) || null;
}

export function getCasePrepBuddySourceOptionById(id) {
  return casePrepBuddySourceOptions.find((option) => option.id === id) || null;
}
